import { render, staticRenderFns } from "./pip-role-level.vue?vue&type=template&id=5b425e8a&scoped=true"
import script from "./pip-role-level.vue?vue&type=script&lang=js"
export * from "./pip-role-level.vue?vue&type=script&lang=js"
import style0 from "./pip-role-level.vue?vue&type=style&index=0&id=5b425e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b425e8a",
  null
  
)

export default component.exports